import { LOGIN_USER, LOGIN_USER_SUCCESS, LOGIN_USER_FAIL, LOGOUT_USER } from '../actions/types'

const INITIAL_STATE = null

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case LOGIN_USER:
      return { ...state, loading: true }
    case LOGIN_USER_SUCCESS:
      const { token, name, user_role, owner_id } = action.payload
      return { ...state, loading: false, token, name, user_role, owner_id }
    case LOGIN_USER_FAIL:
      return { ...state, loading: false, error: action.payload }
    case LOGOUT_USER:
      return INITIAL_STATE
    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js